<template>
    <div>
        <v-alert
            dark
            color="purple"
            icon="mdi-alert-outline"
        >
            Benvindo ao novo módulo de fac do sistema AYT. <br />
            Adicionamos algumas melhorias principalmente na <span class="font-weight-bold"> visualização da ficha, regras de acesso e visualização no celular. </span><br />
            Para maiores informações entre em contato com AYT.

        </v-alert>

        <v-container>
            <v-row 
                :dense="$vuetify.breakpoint.xsOnly"
            >
                <v-col cols="12" xs="1" sm="1" md="4" lg="4" xl="4">

                </v-col> 
                <v-col cols="12" xs="11" sm="11" md="4" lg="4" xl="4">
                    <alert-component :alert="alerts.choice"></alert-component>
                </v-col>
                <v-col cols="12" xs="1" sm="1" md="4" lg="4" xl="4">
                    
                </v-col>  
            </v-row>            
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        dark
                        color="pink"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.store', 
                        }"
                        v-if="can('Cadastrar FAC')"
                    >
                        Cadastrar Nova fac
                    </v-btn>
                </v-col> 
                <v-spacer />   
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        dark
                        color="primary"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.filter', 
                        }"
                    >
                        Pesquisar um fac
                    </v-btn>
                </v-col> 
                <v-spacer/>    
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Nova' | statusFac"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.search',
                            query: {
                                status: 'Nova'
                            } 
                        }"
                    >
                        Nova
                    </v-btn>
                </v-col> 
                <v-spacer/>    
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Em atendimento' | statusFac"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.search',
                            query: {
                                status: 'Em atendimento'
                            } 
                        }"
                    >
                        Em atendimento
                        <span class="ml-1" v-if="me.profile != 'Master' && me.profile != 'Gerente'">
                             da carteira
                        </span>
                    </v-btn>
                </v-col> 
                <v-spacer />   
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Desatualizada' | statusFac"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.search',
                            query: {
                                status: 'Desatualizada'
                            } 
                        }"
                    >
                        Desatualizada

                        <span class="ml-1" v-if="me.profile != 'Master' && me.profile != 'Gerente'">
                             da carteira
                        </span>
                        
                    </v-btn>
                </v-col> 
                <v-spacer />
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Cliente em Espera' | statusFac"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.search',
                            query: {
                                status: 'Cliente em Espera'
                            } 
                        }"
                    >
                        Cliente em Espera

                        <span class="ml-1" v-if="me.profile != 'Master' && me.profile != 'Gerente'">
                             da carteira
                        </span>
                        
                    </v-btn>
                </v-col> 
                <v-spacer />
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Troca de Atendimento' | statusFac"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.search',
                            query: {
                                status: 'Troca de Atendimento'
                            } 
                        }"
                    >
                        Troca de Atendimento

                        <span class="ml-1" v-if="me.profile != 'Master' && me.profile != 'Gerente'">
                             da carteira
                        </span>
                        
                    </v-btn>
                </v-col> 
                <v-spacer />
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Reatendimento' | statusFac"
                        :class="$css_button"
                        block
                        :to="{ 
                            name: 'admin.facs2.search',
                            query: {
                                status: 'Reatendimento'
                            } 
                        }"
                    >
                        Reatendimento
                        <span class="ml-1" v-if="me.profile != 'Master' && me.profile != 'Gerente'">
                             da carteira
                        </span>
                        
                    </v-btn>
                </v-col> 
                <v-spacer />
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AlertComponent from '@/components/alert/AlertComponent.vue'

import { mapGetters } from 'vuex';

export default {
    name: "FacIndex",

    components: {
        AlertComponent
    }, 

    computed: {
        ...mapGetters('permissions', ['can']),

        me () {
            return this.$store.state.auth.me
        },
    },
    
    mounted() {
        window.scrollTo(0, 0);
    },

    data () {
        return {
            alerts: {
                choice: {
                    show: '',
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Escolha uma das opções abaixo.']
                },
            }

        }
    }            
}
</script>